<template>
<div class="right-cont-banner" id="rightContBan">
    <!-- 顶部新导航 -->
    <div class="top-categories">
        <div v-show="!$store.state.isLiteMode" class="top-option" v-for="tabType in tabTypes" :key="tabType.id" @click="switchTabCategories(tabType.id)">
            <span :style="tabCategories==tabType.id?'color: #FFFFFF;':''">{{$t('language.rightTopBanner.nav'+tabType.name)}}</span>
            <div class="top-option-new" v-if="tabType.isNew">{{$t('language.leftBanner.new')}}</div>
            <div class="top-option-select" v-if="tabCategories==tabType.id"></div>
            <div class="top-option-hover" v-else></div>
        </div>
    </div>
    <div class="tourest-text" v-show="$store.state.resetEmail" :style="{width:getTxtWidth()}">
        <div class="icon-mail-hint" style="margin: 4px 10px;"></div>
        <span>{{$t('language.rightTopBanner.bindMailTips')}} </span>
        <button class="bindEmailBtn" @click="bindEmailOpen()" :style="{right:getBtnWidth()}">{{$t('language.rightTopBanner.bind')}}</button>
        <div class="tips-close" @click.stop="close()">{{$t('language.common.close')}}</div>
    </div>
     <div class="browser-prompt" v-show="iePromptShow" :style="{width:getPromptWidth()}">
        <span>
            <font v-html="$t('language.rightTopBanner.browserPrompt')"></font>
        </span>
        <div class="icon-util top-close top-close-button" @click.stop="iePromptShow=false;"></div>
    </div>
    <div class="personal-center">
        <!-- 通知信息图标 -->
        <div class="center-left"  style="width:35Px;position:relative;">
            <!-- <div id="notifyIcon"  class="personal-left notify-icon" @click="getNotifications()"></div> -->
            <div id="licenseIcon" v-if="user.payType!='Lifetime'" class="personal-left license-icon" @click="openLicenseCodePopup()"></div>
            <!-- <div class="red-notify red-notify-position" v-if="newNotifyShow"></div> -->
        </div>
        <div class="center-left">
            <div class="icon-util personal personal-left" :class="personalMenuShow?'personal-hover':''" @click.stop="personalMenuOpen()" v-clickoutside="personalMenuClose">
                <div class="personal-menu" v-show="personalMenuShow" ref="personalMenu" :data-lite="$store.state.isLiteMode">
                    <i class="sharp-angle"></i>
                    <div class="personal-account">
                        <div class="personal-account-item" :title="email">{{email}}</div>
                    </div>
                    <div class="personal-info" @mouseenter="changePass()" @mouseleave="selectMenuIndex=-1">
                        <div class="icon-util properties personal-icon-position" style="top:10Px !important;margin:0 3Px 0Px 3Px !important;"></div>
                        <div class="personal-item">{{$t('language.rightTopBanner.settings')}}</div>
                        <div class="icon-util pull-triangle personal-moremenu-position"></div>
                        <div class="personal-setting-menu" v-show="selectMenuIndex==0" ref="setMenuOne">
                            <div class="personal-info" v-show="!judgeTourist()" @click.stop="changeNameOpen()">
                                <span class="setting-position" ref="changeName"> {{$t('language.rightTopBanner.changeName')}}</span>
                            </div>
                            <div class="personal-info" v-show="!judgeTourist()&&!judgeThird()" @click.stop="changePassOpen()">
                                <span class="setting-position" ref="changePassWord"> {{$t('language.rightTopBanner.changePassword')}}</span>
                            </div>
                            <div class="personal-info" v-show="judgeTourist()" @click.stop="bindEmailOpen()">
                                <span class="setting-position">{{$t('language.rightTopBanner.bindEmail')}}</span>
                            </div>
                            <div class="personal-info" v-show="twoStepverification&&!judgeThird()" @click.stop="openVertificationDialog">
                                 <span class="setting-position" ref="twoStepverifiTxt">{{$t('language.twoStepverification.twoStep')}}</span>
                            </div>
                            <div class="personal-info" @click.stop="deleteAccountOpen()">
                                <span class="setting-position">{{$t('language.rightTopBanner.deleteAccount')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="personal-info" @mouseenter="selectMenuIndex=1" @mouseleave="selectMenuIndex=-1">
                        <div class="icon-util multi-language personal-icon-position"></div>
                        <div class="personal-item">{{$t('language.rightTopBanner.language')}}</div>
                        <div class="icon-util pull-triangle personal-moremenu-position"></div>
                        <div class="personal-setting-menu" v-show="selectMenuIndex==1">
                            <div class="personal-info" v-for="(item, index) in languageArr" :key="index" @click.stop="checkLanguage(index)">
                                <div class="icon-util language-check language-check-position" v-show="checkLanguageIndex==index"></div>
                                <span class="language-position">{{item}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="personal-info" @mouseenter="menuHelpShow()" @mouseleave="selectMenuIndex=-1">
                        <div class="icon-util help personal-icon-position"></div>
                        <div class="personal-item ">{{$t('language.rightTopBanner.help')}}</div>
                        <div class="icon-util pull-triangle personal-moremenu-position"></div>
                        <div class="personal-setting-menu" v-show="selectMenuIndex==2" ref="setMenuTwo">
                            <div class="personal-info" v-for="(item, index) in helpArr" :key="index" @click="openHelpLink(index)">
                                <span class="setting-position" ref="detail">{{item}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 子账号 -->
                    <div class="personal-info" @click.stop="subAccountShow()" v-show="!$store.state.isLiteMode">
                        <div class="icon-util sub-account personal-icon-position"></div>
                        <div class="personal-item ">{{$t('language.rightTopBanner.subAccount')}}</div>
                    </div>
                    <div class="personal-info" @click.stop="getNotifications()">
                        <div class="icon-util notify-icon personal-icon-position" style=""></div>
                        <div class="personal-item">{{$t('language.rightTopBanner.notification')}}</div>
                    </div>
                    <div class="personal-info" @click.stop="logout()">
                        <div class="icon-util logout personal-icon-position" style="margin: 0 1px 0 5px!important;"></div>
                        <div class="personal-item">{{$t('language.rightTopBanner.logout')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="center-right">
            <div class="center-right-position">
                <div v-if="saleShow&&user.payType!='Lifetime'" class="saleImg" @click="salePopupShow(true)" id="saleImg">
                    <!-- <img :src="require('../../assets/images/backToSchool-2023/saleLogo_'+lang+'.gif')"> -->
                    <!-- <img :src="require('../../assets/images/24hFlashSaled-2023/img_word_'+lang+'.png')"> -->
                </div>
                <button class="upgrade-button" @click="switchToPay()" v-if="user.payType=='Lifetime'">
                    <div v-if="payBtn.img" class="right-top-icon icon"  :class="payBtn.img"></div>
                    <div class="payTxt">{{payBtn.txt}}</div>
                </button>
                <button class="upgrade-button" @click="switchToPay()" v-if="user.payType!='Lifetime'" :class="timerExpired?'active-upgrade-button':''">
                    <!-- <div v-if="timerExpired">
                        <div class="payTxt">{{$t('language.valentineSale.payTxt')}}</div>
                        <div class="right-top-icon icon xamsImg"></div>
                        <div class="active-button"></div>
                    </div>
                    <div v-if="!timerExpired">
                        <div v-if="payBtn.img" class="right-top-icon icon"  :class="payBtn.img"></div>
                        <div class="payTxt">{{payBtn.txt}}</div>
                    </div> -->
                    <div v-if="payBtn.img" class="right-top-icon icon"  :class="payBtn.img"></div>
                        <div class="payTxt">{{payBtn.txt}}</div>
                </button>
                <div class="right-content">
                    <div class="progress-bar">
                        <div :class="btnColor=='grey'?'':'inner-progress-bar'" :style="{width:(usedTraffic/totalTraffic)*100+'%'}"></div>
                    </div>
                    <div class="drive-space" v-if="totalTraffic!=-1">
                        {{$t('language.rightTopBanner.traffic')}}:{{usedTraffic|formatByteForBanner}}/{{totalTraffic|formatByteForBanner}}
                    </div>
                    <div class="drive-space" v-else>
                        {{$t('language.rightTopBanner.traffic')}}:{{usedTraffic|formatByteForBanner}}/{{$t('language.rightTopBanner.unlimited')}}
                    </div>
                </div>
            </div>
        </div>
        <div class="top-funnel" v-if="funnelShow">
              <div id="purpleFun" class="purple-funnel" @click="openFunnelPreSet()" >
                     <div class="orange-notice orange-notice-position"  v-if="orangeShow"></div>
              </div>
        </div>
    </div>
    <bindEmailDialog ref="bindEmailDialog"></bindEmailDialog>
    <notificationsDialog ref="notificationsDialog"></notificationsDialog>
    <bindEmailJumpDialog ref="bindEmailJumpDialog"></bindEmailJumpDialog>
    <updateVerificationDialog ref="updateVerificationDialog"></updateVerificationDialog>
    <stepVerificationDialog ref="stepVerificationDialog"></stepVerificationDialog>
    <verifiSettingDialog ref="verifiSettingDialog"></verifiSettingDialog>
    <removeAllDevicesDialog ref="removeAllDevicesDialog"></removeAllDevicesDialog>
    <licenseCodeDialog ref="licenseCodeDialog"></licenseCodeDialog>
    <licenseShowDialog ref="licenseShowDialog" :subscrId="user.subscrId"></licenseShowDialog>
</div>
</template>

<script>
import notificationsDialog from '@/components/popup/personal_center_popups/notifications_popup';
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import googleAnalyticsUtil from "../../js/workspace/google_analytics_util.js";
import bindEmailDialog from '@/components/popup/pay_system_popups/bind_email_topay_popup';
import bindEmailJumpDialog from '@/components/popup/personal_center_popups/bind_email_popup';
//让临时用户绑定邮箱弹窗
import stepVerificationDialog from '@/components/popup/personal_center_popups/stepverification_bind_email_popup';
//验证设置弹窗
import verifiSettingDialog from '@/components/popup/personal_center_popups/verification_setting_popup';
//修改验证弹窗
import updateVerificationDialog from '@/components/popup/personal_center_popups/update_verification_popup';
//移除所有的设备弹窗
import removeAllDevicesDialog from '@/components/popup/personal_center_popups/remove_all_devices_popop';
//兑换码弹窗
import licenseCodeDialog from '@/components/popup/personal_center_popups/license_code_popup';
//兑换码升级用户提示弹窗
import licenseShowDialog from '@/components/popup/personal_center_popups/license_show_popup';
export default {
    data: function () {
        return {
            tabTypes: this.$menu.getTabCategories(),//当前标签类型集合
            tabCategories: this.$store.getters.getTabCategories,//获取当前标签页类型
            personalMenuShow: false,
            languageArr: ['English', 'Deutsch', 'Français', 'Português','Español','Italiano','Nederlands','日本語', '繁體中文', '简体中文'],
            lang: commonUtils.getLocaleToIndex(localStorage.getItem("locale")),
            helpArr: [this.$t('language.rightTopBanner.tutorials'), this.$t('language.rightTopBanner.faq'), this.$t('language.rightTopBanner.contact'), this.$t('language.rightTopBanner.limitsClouds')],
            selectMenuIndex: -1,
            checkLanguageIndex: 0,
            email: '',
            totalTraffic: 0,
            usedTraffic: 0,
            password: '',
            user: commonUtils.getUser(),
            payBtn: {},
            btnColor: '',
            iePromptShow:false,
            funnelShow:false,
            orangeShow:false,
            newNotifyShow:false,
            letNotificationsShow:false,//标识通知信息是否等营销弹窗关闭了再弹出
            letPassWordShow:false,//标识等通知弹窗关闭了再显示密码
            letTimeSalePassWordShow:false,//标识等第一次购买弹窗关闭了再显示临时账号密码
            haveLogout:false,//标识是否退出登录
            twoStepverification:commonstate.twoStepverification,//标识双重验证是否上线
            halloProductArr:[215655,236257,223037],//如果用户购买的产品是以下集合则表示是通过活动购买不是普通购买
            timerExpired: false,//判断活动是否过期
            saleShow: false,//促销活动右上角按钮是否显示
        }
    },
      components:{
        bindEmailDialog,
        notificationsDialog,
        bindEmailJumpDialog,
        stepVerificationDialog,
        verifiSettingDialog,
        updateVerificationDialog,
        removeAllDevicesDialog,
        licenseCodeDialog,
        licenseShowDialog
   },
    created() {
        this.createPage();
    },
    inject: ["reload"],
    mounted() {
        //this.showHalloweenFunnel();
        this.judgeHaveNewNotifications();
        this.showPassWord();
        //禁用该区域的拖拽上传功能
        commonUtils.dragDisAble('rightContBan',this);
        let that = this;
        if (document.getElementById("bindEmailOpen")) {
            document.getElementById("bindEmailOpen").onclick = function () {
                that.$parent.$refs.bindEmail.bindEmailShow = true;
                that.personalMenuShow = false;
            }
        }
        //夏季促销活动暂时关闭
        this.timerExpired = this.getTimerExpired();
        // if(!this.timerExpired){
        //     this.$nextTick(()=>{
        //         this.showFunnel();
        //     });
        // }
        // this.showFunnel();
        let tabCategories;
        if(localStorage.getItem("tabCategories"+this.user.id)) {
            tabCategories = Base64.decode(localStorage.getItem("tabCategories"+this.user.id));
        }
        if(!tabCategories || tabCategories==-1) {
            //如果还未选中标签则默认第一个
            this.switchTabCategories(1);
        }else {
            this.switchTabCategories(tabCategories);
        }
        
    },
    watch:{
        //监听是否更新用户数据
        '$store.state.updateUserSchems': function (newValue, oldValue) {
            this.user = commonUtils.getUser();
            if(newValue) {
              this.$store.commit("setUpdateUserSchems", false);
            }
        },
        '$store.state.tabCategories': function (newValue, oldValue) {
            this.tabCategories = newValue;
        },
    },
    methods: {
        //切换标签页分类，进入标签首页并切换左侧栏标签
        switchTabCategories(type) {
            /**
             * 1：云盘传输功能页
             * 2：图片下载功能页
             * 3：视频下载功能页
             * 4：网页图片下载功能页
             * 5：云盘列表功能页
             */
            this.tabCategories = type;
            this.$store.commit("setTabCategories", type);
            if(type == 3) {
                //视频下载功能页打点
                this.$multcloudGA('video_tag_click');
            }
        },
        //打开双重验证弹窗
        openVertificationDialog(){
            let that = this;
            this.user = commonUtils.getUser();//每次都获取最新的user
            if(!commonstate.emailpattern.test(this.user.email)){
            this.$refs.stepVerificationDialog.verificationShow=true;
             that.personalMenuShow = false;
            return;
            }
            this.Utils.doDualVerifyRequest('get',{userId:this.user.id}).then(res=>{
               //如果是非法的账号
               if(res.reason=='invalidAccount'){
                   that.$refs.verifiSettingDialog.verifiSettingShow=true;
                   that.$refs.verifiSettingDialog.selectOption=[{
						name: this.$t('language.twoStepverification.addPhone'),
						icon: false,
						id: 1
					}];
                   that.$refs.verifiSettingDialog.selectValue=this.$t('language.twoStepverification.addAlEmail');
                   that.$refs.verifiSettingDialog.emailInputShow=true;
                   that.personalMenuShow = false;
                   return;
               }
                that.personalMenuShow = false;
                that.$refs.verifiSettingDialog.userDevices = res.devices;
                that.$refs.updateVerificationDialog.emialValue=res.devices[1];
                that.$refs.updateVerificationDialog.phoneValue=res.devices[0];
                if(!that.$refs.updateVerificationDialog.phoneValue){
                    that.$refs.updateVerificationDialog.txtShow=false;
                }
                if(!that.$refs.updateVerificationDialog.emialValue){
                     that.$refs.updateVerificationDialog.emialShow=false;
                }
                that.$refs.updateVerificationDialog.updateVerifiShow=true;
                that.$refs.updateVerificationDialog.verificationStatus=res.status;
            });
           
        },
        createPage(){
        var that = this;
        commonUtils.refreshUserInfo(this,function(res){
        let user = commonUtils.getUser();
        that.$i18n.locale = localStorage.getItem('locale') || 'english';
        commonUtils.createPayBtn(user,that);
        that.$forceUpdate();
        that.email = user.email;
        that.usedTraffic = user.usedBytes;

        // if(user.vip&&user.payLevel>1){
        // that.usedTraffic = user.payUsedTraffic?user.payUsedTraffic:0;
        // }
        that.totalTraffic = user.totalBytes;
        });
        that.caseLanguageIndex();   
        },
        //根据系统语言显示对应的选项
        caseLanguageIndex(){
            var that = this;
            switch (that.$i18n.locale) {
            case 'english':
                that.checkLanguageIndex = 0;
                break;
            case 'deutsch':
                that.checkLanguageIndex = 1;
                break;
            case 'france':
                that.checkLanguageIndex = 2;
                break;
            case 'portuguese':
                that.checkLanguageIndex = 3;
                break;
            case 'spanish':
                that.checkLanguageIndex = 4;
                break;
            case 'italian':
                that.checkLanguageIndex = 5;
                break;
            case 'nederlands':
                that.checkLanguageIndex = 6;
                break;
            case 'japanese':
                that.checkLanguageIndex = 7;
                break;
            case 'traditionalChinese':
                that.checkLanguageIndex = 8;
                break;
            case 'chinese':
                that.checkLanguageIndex = 9;
                break;
        }
        },
        close(){
          this.$store.state.resetEmail=false;
        },
        //显示万圣节活动弹窗
        showHalloweenFunnel(value){
        var that = this;
        commonUtils.refreshUserInfo(this,function(res){
        let user = commonUtils.getUser();
        //如果用户是终身无线弹窗不显示漏斗
          if(user.vip && user.payType == 'Lifetime'){
             that.funnelShow = false;
             that.orangeShow = false;
             return;
          }
          if(user.vip && user.payType !='Lifetime'){
             var subId = user.subscrId;
             if(user.subscrId.indexOf('-')>0){
                 subId = user.subscrId.slice(0, user.subscrId.indexOf('-'));
             }
              that.Utils.doSubinquiryPostRequest('get_by_id', { subscriptionId: subId }).then(res => {
                if (res.ResultMessage == 'OK') {
                    var itemIndex = res.Subscription.Items.length;
                    var productId = res.Subscription.Items[itemIndex-1].ProductId;
                    var couponcode = res.Subscription.Items[itemIndex-1].Couponcode;
                    if(!that.halloProductArr.includes(productId)||(productId==236257 && couponcode=='')){//说明通过普通活动购买
                     that.$store.state.normalPayUpgrade = true;
                     if(!that.$parent.$refs.halloweenSaleDialog.halloweenSaleShow && !localStorage.getItem('halloweenSale'+user.id)){
                       if(user.payType=='Yearly' || value){
                       localStorage.setItem('halloweenSale'+user.id,'show');
                        that.$parent.$refs.halloweenSaleDialog.halloweenSaleShow = true;
                       }
                     }
                    }
                }
              });
          }
          that.funnelShow = true;
          if(!localStorage.getItem('halloweenSale'+user.id)){
          that.orangeShow = true;    
          }
          //如果用户是付费用户，自动弹出弹窗
          if(!localStorage.getItem('halloweenSale'+user.id) && (user.vip || (user.loginTime && !user.vip)) ){
               if(user.payType=='Yearly' || !user.vip || value){
               localStorage.setItem('halloweenSale'+user.id,'show');
               that.$parent.$refs.halloweenSaleDialog.halloweenSaleShow = true;
                that.letTimeSalePassWordShow = true;
               }
              
          }
          return;
         });
        },
        //是否自动显示弹窗，更改成第一次登录就弹窗
        showFunnel(){
            if(this.salePopupShow(false)){
                return;
            }
            var that = this;
         commonUtils.refreshUserInfo(this,function(res){
          let user = commonUtils.getUser();
          if(!user.vip && user.loginTime){//将用户的loginTime改为createTime
           let nowDateLong = new Date().getTime();//现在时间
           let timeDiff = nowDateLong - user.loginTime;
           let timeDiff72;
           if(user.login72Time){
               timeDiff72 = nowDateLong - user.login72Time;
           }
        //    if((timeDiff <= 86400000)||(user.login72Time&&timeDiff72<=86400000)){
        //      that.funnelShow = true;
        //      that.orangeShow = true;
        //    }
           if(user.login72Time&&timeDiff72<=86400000){
             that.funnelShow = true;
             that.orangeShow = true;
           }
           //显示第一个弹窗  
        //    if(timeDiff && (timeDiff < 86400000) && !localStorage.getItem('timeSale'+user.id)){
        //        let newSign = localStorage.getItem("noviceGuide"+user.id);
        //        if (user.loginTime||newSign) {//弹窗显示不能喝新手引导重合
        //        if(!that.$parent.$refs.leftBanner.beginGuideFlag){
        //        that.letTimeSalePassWordShow = true;
        //        localStorage.setItem('timeSale'+user.id,'show');//表明该用户的营销弹窗已经显示过
        //        that.$parent.$refs.limitedSaledDialog.timeSaleShow = true;
        //        that.$parent.$refs.limitedSaledDialog.contentShow = true;
        //        }
        //        }
              
        //    }
           //显示72H后的弹窗
            if(timeDiff72 && (timeDiff72 < 86400000) && !localStorage.getItem('timeSale'+user.id)){
               localStorage.setItem('timeSale'+user.id,'show');//表明该用户的营销弹窗已经显示过
               that.$parent.$refs.limitedSaledDialog.timeSaleShow = true;
               that.$parent.$refs.limitedSaledDialog.contentUnlimiedShow = true;
           }
          }
            });
        },
        showFunnel72Time(){
            var that = this;
            commonUtils.refreshUserInfo(this,function(res){
                let user = commonUtils.getUser();
                if(!user.vip && user.loginTime){//将用户的loginTime改为createTime
                    let nowDateLong = new Date().getTime();//现在时间
                    let timeDiff72;
                    if(user.login72Time){
                        timeDiff72 = nowDateLong - user.login72Time;
                    }
                    if(user.login72Time&&timeDiff72<=86400000){
                        that.funnelShow = true;
                        that.orangeShow = true;
                    }
                    //显示72H后的弹窗
                    if(timeDiff72 && (timeDiff72 < 86400000) && !localStorage.getItem('timeSale'+user.id)){
                        localStorage.setItem('timeSale'+user.id,'show');//表明该用户的营销弹窗已经显示过
                        that.$parent.$refs.limitedSaledDialog.timeSaleShow = true;
                        that.$parent.$refs.limitedSaledDialog.contentUnlimiedShow = true;
                    }
                }
            });
        },
        openFunnelPreSet(){
          let that = this;
          commonUtils.refreshUserInfo(this,function(res){
               that.user = commonUtils.getUser();
               that.openFunnel();
               //that.openHalloweenFunnel();
          });
        },
        openHalloweenFunnel(){
           this.orangeShow = false;
           this.$parent.$refs.halloweenSaleDialog.halloweenSaleShow=true;
        },
        openFunnel(){
            let user = commonUtils.getUser();
            if(user.vip){
                this.funnelShow = false;
                this.orangeShow = false;
                return;
            }
           let nowDateLong = new Date().getTime();//现在时间
           let timeDiff = nowDateLong - this.user.loginTime;
           let timeDiff72;
           if(this.user.login72Time){
               timeDiff72 = nowDateLong - this.user.login72Time;
           }
           //即登录72H后，小于72+24H，显示无限月推送弹窗
           if(timeDiff72 &&(timeDiff72<86400000)){
                 this.$parent.$refs.limitedSaledDialog.contentUnlimiedShow = true;
                 this.$parent.$refs.limitedSaledDialog.timeSaleShow = true;
                 this.$parent.$refs.limitedSaledDialog.contentShow = false;
                 this.orangeShow = false;
                return;
           }
           if(timeDiff <= 86400000){
            this.$parent.$refs.limitedSaledDialog.contentShow = true;
            this.$parent.$refs.limitedSaledDialog.timeSaleShow = true;
            this.$parent.$refs.limitedSaledDialog.contentUnlimiedShow=false;
           }else {
           //如果界面不刷新还在该界面，还会显示折扣界面，只是倒计时都为0 
           //如果界面倒计时小于4天大于1天
           if(this.funnelShow&&timeDiff>86400000&&timeDiff<345600000){
            this.$parent.$refs.limitedSaledDialog.contentShow = true;
            this.$parent.$refs.limitedSaledDialog.timeSaleShow = true;
            this.$parent.$refs.limitedSaledDialog.contentUnlimiedShow=false;
            return;
           }
           //如果倒计时大于4天
            if(this.funnelShow && this.user.login72Time &&timeDiff>345600000){
            this.$parent.$refs.limitedSaledDialog.contentUnlimiedShow = true;
            this.$parent.$refs.limitedSaledDialog.timeSaleShow = true;
            this.$parent.$refs.limitedSaledDialog.contentShow = false;
            return;
           }
            this.funnelShow=false;
           }
          this.orangeShow = false;
        },
        showPassWord(){
        if(this.letPassWordShow || this.letTimeSalePassWordShow){
            return false;
        }
        let that=this;
         //获取用户
        let Base64 = require('js-base64').Base64;
        let user = commonUtils.getUser();
        if(user.password || localStorage.getItem(user.id+'interimPsd')){
         if(localStorage.getItem(user.id+'interimPsd')){
             this.password  = localStorage.getItem(user.id+'interimPsd');
             user.password =  this.password ;
         }else{
            this.password = user.password;
            if(user.password && user.password.length > 10){
            this.password = new String(Base64.decode(user.password),"utf-8");
            }
         }
        
        }

        //判断是否是游客账号
        if(commonUtils.testUserIsTourist(user)){
            this.$store.state.resetEmail = true;
            this.judgeIeBrowser();
        }else{
            this.$store.state.resetEmail = false;
            this.judgeIeBrowserTimeMore();
        }
        },
        judgeTourist(){//判断是否是游客账号
            let user = commonUtils.getUser();
            if(!user){
                return;
            }
            let result;
             if(user.password){
                result=true;//如果返回了密码所以是临时账号
             }else{
               if(user.email){
                   if(user.email.indexOf('@')==-1){
                       result=true;//如果用户的邮箱不符合格式则是临时账号
                  }else{
                      result=false;
                   }
               }else{
                    result=true;//如果用户邮箱都不存在则是邮箱账号
               }
             }
         return result;
        },
        judgeThird(){//判断是否是第三方登录账号
            let user = commonUtils.getUser();
            if(user.loginType&&user.loginType!="sub"&&!(commonstate.activeLoginTypeList.includes(user.loginType))&&!(commonstate.channelTypeList.includes(user.loginType))&&!(user.userExpandList&&"auth1"==user.userExpandList[0].value)){
                return true;
            }
            return false;
        },
        //判断是否是ie浏览器
        judgeIeBrowser(){
           let that=this;
           var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1;
           if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1&& !isOpera) {//判断是否IE浏览器
            that.iePromptShow=true;
               let t1 = setTimeout(function () {
                 that.iePromptShow=false;
                  clearTimeout(t1);
            }, 5000);
           };
        },
        judgeIeBrowserTimeMore(){
           let that=this;
           var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
           var isOpera = userAgent.indexOf("Opera") > -1;
           if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1&& !isOpera) {//判断是否IE浏览器
            that.iePromptShow=true;
               let t1 = setTimeout(function () {
                 that.iePromptShow=false;
                  clearTimeout(t1);
            }, 10000);
           };
        },
        //获取Txt宽度
        getTxtWidth() {
            let result;
            if (this.$i18n.locale == 'english') {
                result = 730 + 'Px';
            }
            if (this.$i18n.locale == 'japanese') {
                result = 860 + 'Px';
            }
            if (this.$i18n.locale == 'france') {
                result = 875 + 'Px';
            }
            if (this.$i18n.locale == 'deutsch') {
                result = 1000 + 'Px';
            }
            if (this.$i18n.locale == 'spanish') {
                result = 1020 + 'Px';
            }
            if (this.$i18n.locale == 'portuguese') {
                result = 910 + 'Px';
            }
            if (this.$i18n.locale == 'traditionalChinese'||this.$i18n.locale == 'chinese') {
                result = 530 + 'Px';
            }
            return result;
        },
        //获取Txt宽度
        getBtnWidth() {
            let result;
            if (this.$i18n.locale == 'english') {
                result = 60 + 'Px';
            }
            if (this.$i18n.locale == 'deutsch') {
                result = 80 + 'Px';
            }
            if (this.$i18n.locale == 'france'||this.$i18n.locale == 'japanese'||this.$i18n.locale == 'portuguese') {
                result = 70 + 'Px';
            }
            if (this.$i18n.locale == 'spanish') {
                result = 75 + 'Px';
            }
            if (this.$i18n.locale == 'traditionalChinese'||this.$i18n.locale == 'chinese') {
                result = 60 + 'Px';
            }
            return result;
        },
        getPromptWidth() {
            let result;
            if (this.$i18n.locale == 'deutsch'||this.$i18n.locale == 'portuguese') {
                result = 500 + 'Px';
            }
            if (this.$i18n.locale == 'france'||this.$i18n.locale == 'spanish') {
                result = 550 + 'Px';
            }
            if (this.$i18n.locale == 'japanese'||this.$i18n.locale == 'english') {
                result = 450 + 'Px';
            }
            if (this.$i18n.locale == 'traditionalChinese'||this.$i18n.locale == 'chinese') {
                result = 400 + 'Px';
            }
            return result;
        },
        switchToPay() {
            this.user = commonUtils.getUser();
            //活动用户直接跳转活动链接
            if(this.user.vip && this.user.payType=='a202301'){
                window.open("https://d-gogo.com/pages/multcloud-campaign");
                return;
            }
            if (this.user.vip && this.user.payLevel <= 1&&this.user.payType == 'Lifetime') {
                if(this.user.subscrId.slice(0, 2) === "LS") {
                    this.$refs.licenseShowDialog.isShow = true;
                }else {
                    this.$toast({
                        text: this.$t('language.rightTopBanner.lifeTimeNotice'),
                        type: 'success',
                        idValue: "rightContBan"
                    });
                }
            } else {
                googleAnalyticsUtil.pay1(this, "upgrade");
                // if(this.timerExpired){
                //     this.$router.push('/mc_project/paySysActivity');
                // }else{
                    this.$router.push('/mc_project/paySys');
                // }
            }
        },
        onDrag: function (e) {
            e.stopPropagation();
            e.preventDefault();
        },
        personalMenuOpen() {
        let user = commonUtils.getUser();
        this.email = user.email;
        if(this.personalMenuShow){
            this.personalMenuShow = false;
        }else if(!this.haveLogout){
             this.personalMenuShow = true;
        }
        this.caseLanguageIndex();
        },
        personalMenuClose() {
            this.personalMenuShow = false;
            this.selectMenuIndex = -1;
        },
        openHelpLink(index) {
             let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
             let link;
            switch (index) {
                case 0:
                    if(language!='en'&&language!='nl'){
                     link='https://www.multcloud.com/'+language+'/tutorials/index.html';
                    }else{
                      link='https://www.multcloud.com/tutorials/index.html';
                    }
                    break;
                case 1:
                     if(language!='en'&&language!='nl'){
                     link='https://www.multcloud.com/'+language+'/helps';
                     }else{
                      link='https://www.multcloud.com/helps';
                     }
                    break;
                case 2:
                     if(language!='en'){
                     link='https://www.multcloud.com/'+language+'/support';
                     }else{
                     link='https://www.multcloud.com/support';
                     }
                    break;
                case 3:
                    if(language!='en'&&language!='nl'){
                    link='https://www.multcloud.com/'+language+'/help/limitations.html';
                    }else{
                    link='https://www.multcloud.com/help/limitations.html';
                    }
                    break;
            }
             window.open(link, "_blank");
        },
        changePassOpen() {
            let user = commonUtils.getUser();
            this.$parent.$refs.changePass.confrimPassWord = '';
            this.$parent.$refs.changePass.newPassword = '';
            this.$parent.$refs.changePass.email = user.email;
            this.$parent.$refs.changePass.changePassShow = true;
            this.personalMenuShow = false;
        },
        changeNameOpen() {
            let user = commonUtils.getUser();
            this.$parent.$refs.changeName.userName = user.username;
            this.$parent.$refs.changeName.email = user.email;
            this.$parent.$refs.changeName.changeNameShow = true;
            this.personalMenuShow = false;
        },
        //切换语言
        checkLanguage(index) {
            if (this.checkLanguageIndex == index) {
                this.personalMenuShow = false;
            } else if (this.checkLanguageIndex != index) {
                this.reload();
                this.languageIndex = index;
                switch (index) {
                    case 0:
                        this.$i18n.locale = 'english';
                        break;
                    case 1:
                        this.$i18n.locale = 'deutsch';
                        break;
                    case 2:
                        this.$i18n.locale = 'france';
                        break;
                    case 3:
                        this.$i18n.locale = 'portuguese';
                        break;
                    case 4:
                        this.$i18n.locale = 'spanish';
                        break;
                    case 5:
                        this.$i18n.locale = 'italian';
                        break;
                    case 6:
                        this.$i18n.locale = 'nederlands';
                        break;
                    case 7:
                        this.$i18n.locale = 'japanese';
                        break;
                    case 8:
                        this.$i18n.locale = 'traditionalChinese';
                        break;
                    case 9:
                        this.$i18n.locale = 'chinese';
                        break;
                    default:
                        this.$i18n.locale = 'english';
                        break;
                }
                localStorage.setItem('locale', this.$i18n.locale);
            }
        },
        //打开绑定邮箱弹窗
        bindEmailOpen() {
            this.$parent.$refs.bindEmail.bindEmailShow = true;
            this.personalMenuShow = false;
        },
        //打开删除用户账号弹窗
        deleteAccountOpen() {
            let that = this;
            let user=commonUtils.getUser();
            let password;
            const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
            if(user.password){
                password=user.password;
            }
            this.$parent.$refs.deleteAccount.deleteAccountShow = true;
            this.personalMenuShow = false;
             commonUtils.refreshUserInfo(this,function(res){
            if(password){
             user=res;
             user.password=password;
             localStorage.setItem("user", JSON.stringify(user));
             that.$cookies.set("user",JSON.stringify(user),"7d");
             }
            });
        },
        //用户退出系统
        logout() {
            let ud = this.user.id;
            let that = this;
            let exitData = {
                ud: ud
            }
            that.Utils.doUserHaveLoginRequest("exit", exitData).then(result => {
                 that.personalMenuShow = false;
                 that.haveLogout = true;
                 let key = 'monthLy'+this.user.id;//将用户第一次点击的时间点存入缓存
                 let firstTime = localStorage.getItem(key);
                if (result.status == 200) {
                    that.$store.commit('setleftbannerClick', -1);
                    that.$store.commit('setleftbannerMenuClick', 106);
                    let language = commonUtils.caseIndexLanguage(localStorage.getItem("locale"));
                    that.$store.commit("setUsersDrives", []);
                    localStorage.removeItem('timeSale'+this.user.id);
                    if(that.$store.state.halloweenPayUpgrade || !that.user.vip){
                        localStorage.removeItem('halloweenSale'+this.user.id);
                        that.$store.state.halloweenPayUpgrade = null;
                    }
                    commonUtils.logoutAndJumpToSign();
                    // commonUtils.logout_clear();
                    // window.location.href = commonstate.oldVersionUrl + "/action/userinfo!exitLogin?redirect=" + commonstate.frontEndUrl + (language=="en"?"":"/"+language) + "";
                }else{
                    if("saltInvalid"===result.reason){
                        this.$toast({
                            text: this.$t('language.exception.saltInvalid'),
                            type: 'fail',
                            idValue: "rightContBan",
                        });
                    }
                    commonUtils.logout_clear();
                }
                   if(firstTime){
                        localStorage.setItem(key,firstTime);
                    }
            });
        },
        //判断是否有最新的通知消息
        judgeHaveNewNotifications(){
            let that = this;
            let newVerSion;
            if (that.$refs.notificationsDialog&&!that.$refs.notificationsDialog.versions.length) {
                this.Utils.doNotifyRequest("get_version_info", {
                    ud: commonUtils.getUser().id
                }).then(result => {
                    if (result.status == 200) {
                        let versions =result.versions;
                        let timejson = versions.splice(0,1);
                        let notifyTimeStr = timejson[0].infos;
                        let viewTime = commonUtils.getUser().viewTime;
                        notifyTimeStr= String(notifyTimeStr[0]);
                        let notifyTime= new Date(Date.parse(notifyTimeStr)).getTime();
                        if(timejson){
                            that.$refs.notificationsDialog.timejson = timejson;
                        }
                        that.$refs.notificationsDialog.versions = versions;
                        let check=that.$cookies.get('check'+ commonUtils.getUser().id);
                        if(check!='true'&&check!=true){
                            check=false;
                        }
                        if(!viewTime){
                            that.letPassWordShow =true;
                        }
                        if(viewTime < notifyTime){
	                    that.newNotifyShow=true;
                        that.letPassWordShow =true;
                        check= true;//暂时关闭弹窗
                        if(!check){//如果没有设置不再提醒，则弹窗
                        //如果营销弹窗没有显示
                          if(!that.$parent.$refs.limitedSaledDialog.timeSaleShow){
                        that.$refs.notificationsDialog.notificationsShow = true;
                        that.$refs.notificationsDialog.contentShow = true;
                        commonUtils.updateViewTime();
                          }else{
                        that.letNotificationsShow=true;
                          }
                        }
                        }
                    //    that.showPassWord();
                    }
                });
            }
        },
        getNotifications() {
            commonUtils.getNotifications(this);
        },
        openLicenseCodePopup(flag) {
            this.$refs.licenseCodeDialog.isShow = true;
            this.$refs.licenseCodeDialog.flag = flag;
        },
        copyInfo(e) {
            let user = commonUtils.getUser();
            let text = 'Welcome to use MultCloud(https://www.multcloud.com/)' + '\n' + 'Username:' + user.username + '\n' + 'Password:' + this.password + '';
            const clipboard = new this.clipboard(e.target, {
                text: () => text
            })
            clipboard.on('success', e => {
                this.$toast({
                    text: 'Copy successfully!',
                    type: 'success',
                    idValue: "rightContBan"
                });
                // 释放内存
                clipboard.off('error');
                clipboard.off('success');
                clipboard.destroy();
            });
            clipboard.on('error', e => {
                // 释放内存
                clipboard.off('error');
                clipboard.off('success');
                clipboard.destroy();
            });
            clipboard.onClick(e);
        },
        changePass() {
            this.selectMenuIndex = 0;
            this.$refs.setMenuOne.style.width = this.$refs.changePassWord.innerText.length * 7 + 40 + 'Px';
            if(this.twoStepverification){
                // if(this.$i18n.locale == 'deutsch'){
                //      this.$refs.setMenuOne.style.width = 200 + 'Px';
                // }
                 this.$refs.setMenuOne.style.width = this.$refs.twoStepverifiTxt.innerText.length * 7 + 40 + 'Px';
            }
        },
        menuHelpShow() {
            this.selectMenuIndex = 2;
            let divDom = this.$refs.detail[3];
            this.$refs.setMenuTwo.style.width = divDom.innerText.length * 7 + 25 + 'Px';;
        },
          subAccountShow(){
            this.$parent.$refs.subAccount.subAccountShow = true;
            this.personalMenuShow = false;
        },
        getTimerExpired(){
            //新春活动只针对繁体
            // if(localStorage.getItem("locale")!="traditionalChinese"){
            //     return false;
            // }
            return commonUtils.getTimerExpired(commonstate.activityEndedTimer);
        },
        //是否显示促销活动
        salePopupShow(isClick){
            let newSign = localStorage.getItem("noviceGuide"+this.user.id);
            if (this.user.loginTime||newSign) {//弹窗显示不能喝新手引导重合
                if(this.$store.state.beginGuideFlag){
                    return;
                }
            }
            if(this.user.payType=="Lifetime"){
                this.saleShow = false;
                return;
            }
            //获取结束时间
            var that = this;
            if(this.getTimerExpired()){
                //活动未结束则开启活动
                that.Utils.doUserHaveLoginRequest('getUpShellActiveTime', {
                    ud: that.user.id,
                    salt: that.user.salt,
                    upShellActiveType: "valentineSale2026",
                }).then(response => {
                    if(response.status == 200){
                        var upShellActiveTime = response.upShellActiveTime;
                        if(upShellActiveTime) {
                            if(!isClick){
                                //右上角显示
                                that.saleShow = true;
                                let noOpen = true;

                                //标记已经打开过弹窗
                                var closeTime = localStorage.getItem("valentineSaleClose")
                                var nowTime = new Date().getTime();
                                if(!closeTime || (nowTime - closeTime > (24*60*60*1000))){
                                    //未打开弹窗则记录打开过弹窗
                                    //已打开超过24小时
                                    localStorage.setItem("valentineSaleClose",nowTime);
                                    noOpen = false;
                                }
                                if(!noOpen){
                                    //打开活动
                                    that.$parent.$refs.limitedSaledDialog.showPopup(commonUtils.getUser(),upShellActiveTime);
                                }
                            }else{
                                //打开活动
                                that.$parent.$refs.limitedSaledDialog.showPopup(commonUtils.getUser(),upShellActiveTime);
                            }
                        }else{
                            let changeData = {
                                ud: that.user.id,
                                upShellActiveTime: new Date().getTime()+(24*60*60*1000),
                                upShellActiveType: "valentineSale2026",
                                upShellActiveDayNum: 90,
                            }
                            that.Utils.doUserHaveLoginRequest("saveUpShellActiveTime", changeData).then(res => {
                                //右上角显示
                                that.saleShow = true;
                                //打开活动
                                that.$parent.$refs.limitedSaledDialog.showPopup(commonUtils.getUser(),changeData.upShellActiveTime);
                                //未打开弹窗则记录打开过弹窗
                                localStorage.setItem("valentineSaleClose",changeData.upShellActiveTime);
                            });
                        }
                    }
                })
            }else{
                //如果不打开活动，就校验72小时弹窗
                that.showFunnel72Time();
            }
            return true;
        },
        //是否显示app推荐弹窗
        appRecommendShow(){
            //暂不开放
            this.showFunnel();
            return;
            let that = this;
            var isClose = localStorage.getItem("appRecommendClose")
            if(!isClose){
                //如果没有打开过app推荐弹窗，则到后端进行判断是否弹窗
                let data = {
                    ud: that.user.id,
                    tag: 'appRecommend',
                }
                that.Utils.doAcvieTagRequest("get_by_tag", data).then(res => {
                    //打开活动
                    if(res.code==200&&res.data.appRecommend){
                        //如果存在该标签并且有至少一个，则不弹出，否则弹窗
                        if(res.data.appRecommend.length==0){
                            //提交标签,并弹窗
                            that.Utils.doAcvieTagRequest("save_tag", {ud: that.user.id,tag: 'appRecommend', }).then(res2 => {
                                if(res.code==200){
                                    //获取当前浏览器类型
                                    let type = commonUtils.judgeClient();
                                    if(type == 'Android'){
                                        that.$parent.$refs.appRecommendMobileDialog.mobileType = type
                                        that.$parent.$refs.appRecommendMobileDialog.isShow = true;
                                    }else if(type == 'IOS'){
                                        that.$parent.$refs.appRecommendMobileDialog.mobileType = type;
                                        that.$parent.$refs.appRecommendMobileDialog.isShow = true;
                                    }else{
                                        //默认web端
                                        that.$parent.$refs.appRecommendDialog.isShow = true;
                                    }
                                    //本地换成记录
                                    localStorage.setItem("appRecommendClose",true);
                                }else {
                                    that.showFunnel();
                                }
                            });
                        }else {
                            that.showFunnel();
                        }
                    }else {
                        that.showFunnel();
                    }
                });
            }else {
                that.showFunnel();
            }
        }
    },
}
</script>

<style>
@charset "utf-8";
.red-notify{
      width: 12Px;
      height: 12Px;
      background-color:red;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-border-radius: 50%;
}

.red-notify-position{
    position: relative;
    left: 22Px;
    top: 13Px;
}

.payTxt {
    float: left;
}

.bindEmailBtn {
    padding: 0 20px !important;/*no*/
    height: 26px;/*no*/
    border-style: none;
    outline: 0;
    border-radius: 5px;
    /*no*/
    cursor: pointer;
    color: #fff;
    background-color: #5166bd;
    float: right;
    position: absolute;
    top: 6px;
    /*no*/
    right: 60px;
    /*no*/
    bottom: 0;
}

.tourest-text {
    width: 730px;/*no*/
    display: inline-flex;
    line-height: 22px;/*no*/
    font-family: ArialMT;
    color: #222222;
    height: 40Px;
    position: absolute;
    margin: auto;
    top: 30%;
    /*no*/
    bottom: 0;
    left: -10%;
    right: 0;
    border-radius: 5px;
    /*no*/
    font-size: 12px;
    /*no*/
    z-index: 1;
    box-sizing: border-box;
    padding: 8px 10px;
    /*no*/
    background-color: #EAEEFA;
    border: 1px solid rgba(127, 155, 246, 0.5019607843137255);/*no*/
}
.browser-prompt {
    width: 450px;
    /*no*/
    height: 45Px;
    position: absolute;
    margin: auto;
    top: 0;
    /*no*/
    bottom: 0;
    left: -25%;
    right: 0;
    border: 1px solid #8a96e3;
    /*no*/
    border-radius: 5px;
    /*no*/
    font-size: 12px;
    /*no*/
    z-index: 1;
    box-sizing: border-box;
    padding: 5px 10px;
    /*no*/
    line-height: 35px;
    /*no*/
}
.personal-icon-position {
    float: left;
    position: relative;
    left: 15px;
    /*no*/
    top: 10px !important; /*no*/
    margin: 0px 3px !important;/*no*/
}

.personal-moremenu-position {
    float: right;
    position: relative;
    top: 7px;
    /*no*/

}


.pentagram {
    width: 20px;
    /*no*/
    height: 10px;
    /*no*/
    background-position: -605px -60px;
    /*no*/
}



.personal-left {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}

.personal-center {
    height: 100%;
    float: right;
    margin-right: 30px;
    /*no*/
}

.upgrade-position {
    height: 25px;
    /*no*/
    line-height: 16px;
    /*no*/
}

.center-left {
    width: 60px;
    /*no*/
    float: left;
    height: 100%;
    position: relative;

}

.center-right {
    min-width: 275px;
    /*no*/
    float: left;
    height: 100%;
    position: relative;
}

.progress-bar {
    border-radius: 5px;/*no*/
    width: 160px;
    /*no*/
    background-color: rgba(255, 255, 255, 0.2);
    height: 10px;
    /*no*/
}

.inner-progress-bar {
    border-radius: 5px;/*no*/
    background-color: #C1CBE3;
    height: 100%;
    width: 0%;
    max-width: 100%;
}

.upgrade-button {
    background: linear-gradient(173deg, #FFA133 5%, #F58427 76%);
    border-radius: 4px;
    /*no*/
    height: 28px;
    /*no*/
    font-family: Arial;
    font-size: 12px;
    /*no*/
    float: right;
    font-weight: bold;
    text-align: center;
    line-height: 28Px;
    color: #fff;
}

.upgrade-button:hover {
    background-color: #F1C159;
    cursor: pointer;
}

.upgrade-button:active {
    background-color: #FFAA46;
}

.upgrade-button img {
    margin-right: 5Px;
    vertical-align: middle;
    float: left;
    position: relative;
    top: 2Px;
}

.pentagram-positon {
    float: left;
    margin-right: 2%;
    position: relative;
    top: -2px;
    /*no*/
}

.drive-space {
    color: #C1CBE3;
    height: 66%;
    font-size: 12px;
    /*no*/
    text-align: left;
    line-height: 25Px;
}

.right-content {
    /*no*/
    height: 100%;
    float: left;
    margin-right: 20Px;
    margin-left: 20px;/*no*/
}

.center-right-position {
    width: 100%;
    height: 30px;
    /*no*/
    margin-top: 30Px;
    /*no*/
    position: relative;
}

.center-right-position::after {
    content: '';
    width: 1px;/*no*/
    height: 16px;/*no*/
    position: absolute;
    top: 7px;/*no*/
    left: -1px;/*no*/
    background: rgba(255, 255, 255, 0.1);
}

.personal-menu {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 215px;
    /*no*/
    height: 259px;
    /*no*/
    border-radius: 4px;
    /*no*/
    border: 0px solid #8a96e3;
    /*no*/
    background: #FFF;
    position: absolute;
    z-index: 600;
    top: 50Px;
    right: -94px;
    /*no*/
    box-shadow: 0px 10px 10px 0px rgba(87, 94, 136, 0.3);
    /*no*/
}

.personal-menu[data-lite="true"] {
    height: 224px;
}

.personal-setting-menu {
    position: absolute;
    z-index: 900;
    min-width: 160px;
    /*no*/
    border: 1px solid #8a96e3;
    /*no*/
    left: 215px;
    /*no*/
    background: #fff;

}

.language-position {
    float: left;
    position: absolute;
    left: 50px;
    /*no*/
}

.setting-position {
    float: left;
    position: absolute;
    left: 20px;
    /*no*/
}

.personal-account {
    width: 100%;
    height: 50px;
    /*no*/
    border-bottom: 1px solid #f8f8f8;
    /*no*/
    display: table;
    text-align: center;
}

.personal-info {
    width: 100%;
    height: 34.6px;
    /*no*/
    color: #6f7886;
    line-height: 35px;
    /*no*/
    font-size: 14px;
    /*no*/
    float: left;
}

.personal-logout {
    width: 100%;
    height: 35px;
    /*no*/
    border-top: 1px solid #f8f8f8;
    /*no*/
    line-height: 35px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #6f7886;
}

.personal-info:hover,
.personal-logout:hover {
    background: #d7e7ff;
    cursor: pointer;
}

.personal-item {
    position: relative;
    left: 25px;
    /*no*/
    float: left;
}

.personal-account-item {
    max-width:45Px;
    /*no*/
    text-overflow: ellipsis;
    overflow: hidden !important;
    white-space: nowrap !important;
    vertical-align: middle;
    display: table-cell;
    padding: 0 10Px 0 10Px;
}

.personal-plan {
    color: #a3adbd;
    font-size: 12px;
    /*no*/
    float: left;
    position: relative;
    left: 45px;
    /*no*/
}

.personal-account-position {
    position: relative;
    top: 13px;
    /*no*/
}

.language-check-position {
    position: relative;
    float: left;
    top: 7px;
    /*no*/
    left: 19px;
    /*no*/
}

.unlimited {
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-image: url("../../assets/images/workspace/unlimited.png");
    float: left;
}

.orange-notice{
    width: 11px;
    /*no*/
    height: 11px;
    /*no*/
    background-image: url("../../assets/images/workspace/tanhao.png");
}

.upgrade-class {
    float: left;
    margin-left: 5px;
    /*no*/
    line-height: 20px;
    /*no*/
}

.top-close-button {
    float: right;
    position: absolute;
    top: 11Px;
    right: 10Px;
    cursor: pointer;
}

.top-funnel{
    width: 20Px;
    height: 100%;
    float: left;
    margin-left: 20Px;
    cursor: pointer;
}

.purple-funnel{
     width: 16px;
    /*no*/
    height: 26px;
    /*no*/
    background-image: url("../../assets/images/workspace/shalou.png");
    float: left;
    background-repeat: no-repeat;
    margin-top: 20Px;
    position: relative;

}

.orange-notice-position{
    position: absolute;
    left: 10Px;
    top: -6Px;
}

.tips-close{
    cursor: pointer;
    right: 20px;/*no*/
    position: absolute;
    font-size: 12px;/*no*/
    line-height: 24px;/*no*/
    color: #6F6F6F;
}

.saleImg {
    float: right;
    width: 88Px;
    height: 40Px;
    margin-left: 10Px;
    margin-top: -10Px;
    cursor: pointer;
    background: url("../../assets/images/world-backup-day-2026/bg_card.gif") no-repeat;
    background-size: 100%;
    text-align: center;
}
.saleImg img {
    margin: 4px auto;/*no*/
    padding-left: 15px;/*no*/
}
/* 顶部新导航 */
/*右上导航栏*/
.right-cont-banner {
    width: 100%;
    height: 90px;
    /*no*/
    background-color: #293166;
    position: absolute;
    display: flex;
    justify-content: space-between;
 
}
/* 顶部新导航项 */
.top-categories {
    float: left;
    height: 100%;
    flex-grow: 1;
    margin-left: 5px;/*no*/
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.top-categories .top-option {
    height: 90px;/*no*/
    line-height: 90px;/*no*/
    font-size: 16px;/*no*/
    font-weight: bold;
    letter-spacing: 0em;
    color: #C1CBE3;
    position: relative;
    margin: 0 15px;/*no*/
    cursor: pointer;
    white-space: nowrap;
}

.top-categories .top-option span {
    position: relative;
    z-index: 1;
}
/* 顶部新导航项选中 */
.top-categories .top-option:hover .top-option-hover {
    position: absolute;
    bottom: 1px;/*no*/
    background: #FFFFFF;
    width: 100%;
    opacity: 0.2;
    height: 3px;/*no*/
}

.top-categories .top-option .top-option-select {
    position: absolute;
    bottom: 0;
    background: #FFFFFF;
    width: 100%;
    height: 4px;/*no*/
}


.top-option-new{
    top: 12px;/*no*/
    right: -18px;/*no*/
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 8.5px;/*no*/
    background: linear-gradient(270deg, #FF7913 0%, #FF4646 102%);
    box-shadow: 0px 4px 8px 0px rgba(255, 26, 0, 0.2);/*no*/
    width: auto;
    min-width: 25px;/*no*/
    height: 24px;/*no*/
    border-radius: 24px 24px 24px 1px;/*no*/
    font-family: Roboto;
    font-size: 12px;/*no*/
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/right_top_banner.vue